import React, { useMemo, useState } from 'react';
import './ColumnSelectorDrawer.css';

const ColumnSelectorDrawer = ({ open, onClose, headers = [], hiddenColumns = [], setTableState }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!open) return null;

  const toggleColumn = (field) => {
    setTableState((prev) => ({
      ...prev,
      hiddenColumns: prev.hiddenColumns.includes(field)
        ? prev.hiddenColumns.filter((c) => c !== field)
        : [...prev.hiddenColumns, field],
    }));
  };

  const hideAll = () => {
    setTableState((prev) => ({
      ...prev,
      hiddenColumns: headers.map((h) => h.field),
    }));
  };

  const showAll = () => {
    setTableState((prev) => ({
      ...prev,
      hiddenColumns: [],
    }));
  };

  return (
    <div className="column-drawer-overlay" onClick={onClose}>
      <div className="column-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="column-drawer-header">
          <div> 
            <span>Find column</span>
            <button onClick={onClose}>Close</button>
          </div>
         
          <input placeholder="Column title" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>

        <div className="column-drawer-body">
          {headers
            .filter((col) => col.headerName.toLowerCase().includes(searchTerm.toLowerCase()))
            .map((col) => {
              const visible = !hiddenColumns.includes(col.field);

              return (
                <div key={col.field} className="column-item">
                  <label className="switch">
                    <input type="checkbox" checked={visible} onChange={() => toggleColumn(col.field)} />
                    <span className="slider" />
                  </label>
                  <span className="column-label">{col.headerName}</span>
                </div>
              );
            })}
        </div>

        <div className="column-drawer-footer">
          <button onClick={hideAll}>Hide All</button>
          <button onClick={showAll}>Show All</button>
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectorDrawer;
